export default __webpack_public_path__ + "static/media/GlossaryEmptyStateBackground.68fd9be6.svg";